import React, { useCallback } from "react";
import { ChakraProps } from "@chakra-ui/react";
import { AsyncSearchProvider } from "./AsyncSearchProvider";
import AsyncSelect from "./AsyncSelect";
import useEquipmentSlots from "../../hooks/equipmentSlots/useEquipmentSlots";

interface SelectEquipmentSlotProps extends ChakraProps {
  value: string;
  setValue: (value: string) => void;
}

const SelectEquipmentSlot: React.FC<SelectEquipmentSlotProps> = ({ color, value, setValue, ...chakraProps }) => {
  const { isLoading, error, equipmentSlots = [] } = useEquipmentSlots();

  const handleSearch = useCallback(
    async (searchQuery?: string): Promise<[string, string][]> => {
      return equipmentSlots
        .filter((equipmentSlot) =>
          searchQuery ? equipmentSlot.displayName.toLowerCase().includes(searchQuery.toLowerCase().trim()) : true
        )
        .map(({ slotName, displayName }) => [slotName, displayName]);
    },
    [equipmentSlots]
  );

  return (
    <AsyncSearchProvider onSearchAsync={handleSearch}>
      <AsyncSelect
        selectedValue={value}
        setSelectedValue={setValue}
        color={color}
        title={"Equipment Slot"}
        isLoading={isLoading}
        error={error}
        {...chakraProps}
      />
    </AsyncSearchProvider>
  );
};

export default SelectEquipmentSlot;
